import {Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {MessageService} from "../../utils/message/message.service";
import {LanguagePickerService} from "../../utils/language-picker/language-picker.service";
import {BannerApiService} from "../../api/banner-api.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-super-admin-banner',
  templateUrl: './super-admin-banner.component.html',
  styleUrls: ['./super-admin-banner.component.scss']
})
export class SuperAdminBannerComponent {

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private messageService: MessageService,
    private languagePickerService: LanguagePickerService,
    private bannerApi: BannerApiService,
    private translate: TranslateService
  ) {
    bannerApi.getBanner().subscribe((banner) => {
      this.databaseText = banner.bannerText;
      this.databaseUrl = banner.bannerUrl;
    });
  }

  loading: boolean = false;
  selectedFile: File;
  databaseImage: any;
  databaseText: string;
  databaseUrl: string;

  goBack() {
    this.router.navigate(['/sa/home'])
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  public onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  downloadImage() {
    this.bannerApi.downloadBanner().subscribe((banner) => {
      this.databaseImage = 'data:image/jpeg;base64,' + banner.bannerImage;
    });
  }

  uploadImage() {
    this.loading = true;
    const imageData = new FormData();
    imageData.append('imageFile', this.selectedFile, this.selectedFile.name);
    this.bannerApi.setImage(imageData).subscribe(response => {
      if (response.success) {
        this.loading = false;
        this.messageService.info(this.translate.instant('admin.banner.messages.imageSuccess'));
      } else {
        this.loading = false;
        console.log(response.httpError);
        this.messageService.error(this.translate.instant('admin.banner.messages.imageError'));
      }
    });
    this.databaseImage = '';
  }

  uploadText() {
    this.bannerApi.setText(this.databaseText).subscribe(response => {
      if (response.success) {
        this.messageService.info(this.translate.instant('admin.banner.messages.textSuccess'));
      } else {
        this.messageService.error(this.translate.instant('admin.banner.messages.textError'));
      }
    });
  }

  uploadUrl() {
    const urlToSend = this.databaseUrl && this.databaseUrl.trim() !== ''
      ? this.databaseUrl.trim()
      : null;

    this.bannerApi.setUrl(urlToSend).subscribe(response => {
      if (!response || response.success) {
        this.messageService.info(this.translate.instant('admin.banner.messages.urlSuccess'));
        this.databaseUrl = urlToSend;
      } else {
        this.messageService.error(this.translate.instant('admin.banner.messages.urlError'));
      }
    });
  }
}
